<mp-filter-group
  [filterName]="filterName() || ''"
  [icon]="icon()"
  [filterNameTemplate]="filterNameTemplate"
  [customSearchTemplate]="customSearchTemplate"
  [searchable]="true"
  [scrollable]="isScrollable()"
  [isExpanded]="isExpanded"
  [isSearchExpanded]="isSearchExpanded"
  (isExpandedChange)="onExpandedChange($event)"
  (isSearchExpandedChange)="setSearchExpanded($event)"
>
  @if (selectedBucket(); as selectedBucket) {
    <mp-filter-selection-info filter-group-selection-info class="truncate" [label]="selectedBucket.label" />
  }

  @if (selectedBucket()) {
    <mp-filter-clear-button filter-group-clear-filter-action (clearFilter)="clearSelection()" />
  }

  <div class="facet-buckets-list">
    <!-- At the moment, skip root node -->
    <!-- <ng-container *ngTemplateOutlet="bucket; context: { $implicit: facet.root, level: 0 }"></ng-container> -->
    @if (facet().root.children?.length) {
      @for (child of facet().root.children; track child.value) {
        <ng-container *ngTemplateOutlet="bucketTemplate; context: { $implicit: child, level: 1 }" />
      }
    } @else {
      <p class="facet-buckets-list__no-buckets-info">{{ noBucketsInfoText() }}</p>
    }
  </div>
</mp-filter-group>

@if (isExpanded && showMaximizeButton()) {
  <mp-maximize-list-button [maximized]="isMaximized()" (toggleMaximizeList)="isMaximized.set(!isMaximized())" />
}

<ng-template #filterNameTemplate>
  @if (typeFacet(); as typeFacet) {
    @if (typeFacet.buckets.length && isExpanded) {
      @if (typeFacet.buckets.length > 1) {
        <mp-type-facet-value-selector
          [typeFacet]="typeFacet"
          [selectedTypeFacetBucket]="selectedTypeBucket()"
          (selectedTypeFacetBucketChange)="handleTypeChange($event)"
        />
      } @else {
        <span>{{ typeFacet.buckets[0].label }}</span>
      }
    } @else {
      <span>{{ selectedTypeBucket()?.label }}</span>
    }
  } @else {
    <span>{{ filterName() }}</span>
  }
</ng-template>

<ng-template #customSearchTemplate>
  <mp-tree-facet-autocomplete
    #treeFacetAutocomplete
    [searchFieldPlaceholder]="searchFieldPlaceholder()"
    [allBuckets]="allBuckets()"
    (bucketSelected)="handleSearchOptionClick($event)"
    (searchFieldUse)="onSearchFieldUse()"
  />
</ng-template>

<ng-template #bucketTemplate let-bucket let-level="level">
  <mp-tree-facet-bucket
    class="tree-facet-bucket"
    [bucket]="bucket"
    [isSelected]="bucket.selected"
    [isExpanded]="isBucketExpanded(bucket)"
    (isExpandedChange)="onBucketExpandedChange(bucket, $event)"
    (bucketClick)="setSelectedBucket(bucket)"
  >
    <ng-template>
      @for (child of bucket.children ?? []; track child.value) {
        <ng-container *ngTemplateOutlet="bucketTemplate; context: { $implicit: child, level: level + 1 }" />
      }
    </ng-template>
  </mp-tree-facet-bucket>
</ng-template>
